"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToastAnimator = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var react_animate_height_1 = require("react-animate-height");
var react_transition_group_1 = require("react-transition-group");
var Animation_1 = require("../../utils/Animation");
var ToastBase_1 = require("./ToastBase");
/**
 * This Wrapper will handle animating Toasts in/out.
 * It transitions both their height and opacity.
 * It's built using a combination of React's `TransitionGroup` and a 3rd party library called `react-animate-height`.
 */
var ToastAnimator = /** @class */ (function (_super) {
    tslib_1.__extends(ToastAnimator, _super);
    function ToastAnimator() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            transitionHeights: {},
        };
        _this.childFactory = function (child) {
            var toastId = _this.findToastId(child);
            return React.cloneElement(child, {
                height: _this.getHeight(toastId),
            });
        };
        return _this;
    }
    ToastAnimator.prototype.handleEnter = function (toastId) {
        var _a;
        this.setState({ transitionHeights: tslib_1.__assign(tslib_1.__assign({}, this.state.transitionHeights), (_a = {}, _a[toastId] = 'auto', _a)) });
    };
    ToastAnimator.prototype.handleExit = function (toastId) {
        var _a;
        this.setState({ transitionHeights: tslib_1.__assign(tslib_1.__assign({}, this.state.transitionHeights), (_a = {}, _a[toastId] = 0, _a)) });
    };
    ToastAnimator.prototype.getHeight = function (toastId) {
        return this.state.transitionHeights[toastId] || 0;
    };
    ToastAnimator.prototype.findToastId = function (child) {
        var findToastBaseChild = function (element) {
            var _a;
            // Reach inside the Transition, then the AnimateHeight, (and potentially the AutoDismissWrapper) to get the Toast, and its toastId.
            if (element.type === ToastBase_1.ToastBaseWidget) {
                return element;
            }
            return ((_a = element.props) === null || _a === void 0 ? void 0 : _a.children) ? findToastBaseChild(element.props.children) : null;
        };
        var toast = findToastBaseChild(child);
        return toast && toast.props.id || '';
    };
    ToastAnimator.prototype.render = function () {
        var _this = this;
        return React.createElement(react_transition_group_1.TransitionGroup
        // TransitionGroup will not update exiting children's props without a childFactory
        , { 
            // TransitionGroup will not update exiting children's props without a childFactory
            childFactory: this.childFactory, style: this.props.style }, React.Children.map(this.props.children, function (child, index) {
            var toastId = _this.findToastId(child) || index.toString();
            return React.createElement(react_transition_group_1.Transition, { appear: true, key: toastId, onEnter: function () { return _this.handleEnter(toastId); }, onExit: function () { return _this.handleExit(toastId); }, timeout: Animation_1.AnimationDuration },
                React.createElement(react_animate_height_1.default, { animateOpacity: true, duration: Animation_1.AnimationDuration, height: _this.getHeight(toastId) }, child));
        }));
    };
    return ToastAnimator;
}(React.Component));
exports.ToastAnimator = ToastAnimator;
//# sourceMappingURL=ToastAnimator.js.map